module.exports = __webpack_public_path__ + "static/media/feat-olympic-img1.e7c930dd.jpg";